import { addDays, isSameDay, parseISO } from 'date-fns';
import { DayCell } from './DayCell';
import type { CalendarSlot } from '../../stores/calendarStore';

interface WeekGridProps {
  slots: CalendarSlot[];
  weekStart: Date;
}

export function WeekGrid({ slots, weekStart }: WeekGridProps) {
  const days = Array.from({ length: 7 }, (_, i) => addDays(weekStart, i));

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-7 gap-2 min-h-[300px] md:min-h-[400px] flex-1">
      {days.map((day) => {
        const daySlots = slots.filter((slot) =>
          isSameDay(parseISO(slot.scheduled_at), day)
        );

        return (
          <DayCell
            key={day.toISOString()}
            date={day}
            slots={daySlots}
          />
        );
      })}
    </div>
  );
}

export default WeekGrid;
